import { ControlTemplate } from 'dac-web-ui/src/controlTemplate';
import { API } from '../api';

export class DataManager extends ControlTemplate {
	constructor( modules, managers ) {
		super();
		this.modules = modules;
		this.managers = managers;

		this.managers.DataManager = this;

		this.data = {
			estructuras: null,
			anchos: null,
			mallas: null,
			cabeceras: null,
			preguntas: null,
			respuestas: null
		};

		this.currentData = {
			estructura: null,
			ancho: null,
			largo: null,
			capillas: null,
			malla: null,
			respuestas: []
		};
	}

	#initUrl() {
		if (location.host === 'localhost:9002') {
			sessionStorage.setItem('backendUrl', process.env.NODE_ENV === 'development' ? 'http://localhost:1337' : '/backend');
		} else {
			sessionStorage.setItem('backendUrl', '/backend');
		}
	}

	#cleanStrapiData( rawObj ) {
		let data = [];
		if( !rawObj || !rawObj.data ) return null;
		
		const clearObj = (obj) => {
			delete obj.attributes.createdAt;
			delete obj.attributes.publishedAt;
			delete obj.attributes.updatedAt;
			obj.attributes.id = obj.id;
			
			//iterate over properties that are objects and have data property in them
			Object.keys(obj.attributes).forEach( key => {
				const child = obj.attributes[key];
				if( typeof child === 'object' && child && child.data ) {
					obj.attributes[key] = this.#cleanStrapiData( child );
				}
				if( typeof child === 'string' && (child.toLowerCase() === 'false' || child.toLowerCase() === 'falso')  ) {
					obj.attributes[key] = false;
				}
				if(  typeof child === 'string' && (child.toLowerCase() === 'true' || child.toLowerCase() === 'verdadero')  ) {
					obj.attributes[key] = true;
				}
			});
			return obj;
		} ;


		if ( Array.isArray( rawObj.data ) ) {

			rawObj.data.forEach((obj) => {
				
				clearObj(obj);

				data.push(obj.attributes);
			});
		} else if( typeof rawObj.data === 'object' && rawObj.data ) {
			data = clearObj( rawObj.data ).attributes;
		}

		return data;
	}

	async init() {

		this.#initUrl();

		await this.#getEstructuras();
		await this.#getAnchos();
		await this.#getMallas();
		await this.#getCabeceras();
		await this.#getPreguntas();
		await this.#getRespuestas();
		await this.#getProhibicionesInt();
		await this.#getProhibicionesAm();
		//await this.#getObjetos();
		
		//add default answer and possible options to each question
		if( this.data.preguntas && this.data.respuestas ) {
			console.log(this.data.preguntas);
			console.log(this.data.cabeceras);
			this.data.preguntas.forEach( pregunta => {
				pregunta.CABOPTOpciones = this.data.respuestas.filter( r => r.DETOPTOpcion==pregunta.CABOPTOpcion );
				pregunta.CABOPTDefecto = pregunta.CABOPTOpciones.find(r => r.DETOPTDefecto==true );
				pregunta.grupo =this.data.cabeceras.find(obj=>obj.Codigo==pregunta.CABOPTOpcion).Grupo;
				pregunta.nombre =this.data.cabeceras.find(obj=>obj.Codigo==pregunta.CABOPTOpcion).Nombre;
				//add default answer to currentData
				this.currentData.respuestas.push( pregunta.CABOPTDefecto );
			} );
		}
		
	}

	getAnchos() {
		return this.currentData.estructura ? this.data.anchos.filter(a => a.ALGOVALANCEstru == this.currentData.estructura.codaqua ).
			map( a => a.ALGOVALAncho ) : [];
	}

	getMallas() {
		return this.currentData.estructura ? this.data.mallas.filter( m => m.ALGOVALMALEstru == this.currentData.estructura.codaqua ).
			map( m => m.ALGOVALMalla ) : [];
	}

	getPreguntas() {
		return this.currentData.estructura ? this.data.preguntas.filter( p => p.CABOPTOpcion == this.currentData.estructura.codaqua ) : [];
	}

	//download all estructuras
	async #getEstructuras( clearData = true ) {

		if( !this.data.estructuras || clearData ) {
			const data = await API.getEstructuras();
			this.data.estructuras = this.#cleanStrapiData( data );
		}
		
		return this.data.estructuras;
	}

	//download all anchos
	async #getAnchos( clearData = true ) {
		
		if( !this.data.anchos || clearData ) {
			const data = await API.getAnchos();
			this.data.anchos = this.#cleanStrapiData( data );
		}

		return this.data.anchos;
	}

	//download all mallas
	async #getMallas( clearData = true ) {
		
		if( !this.data.mallas || clearData ) {
			const data = await API.getMallas();
			this.data.mallas = this.#cleanStrapiData( data );
		}

		return this.data.mallas;
	}

	//download all cabeceras
	async #getCabeceras( clearData = true ) {
		
		if( !this.data.cabeceras || clearData ) {
			const data = await API.getCabeceras();
			this.data.cabeceras = this.#cleanStrapiData( data );
		}

		return this.data.cabeceras;
	}

	//download all preguntas
	async #getPreguntas( clearData = true ) {
		
		if( !this.data.preguntas || clearData ) {
			const data = await API.getPreguntas();
			this.data.preguntas = this.#cleanStrapiData( data );			
		}

		return this.data.preguntas;
	}

	//download all respuestas
	async #getRespuestas( clearData = true ) {
		
		if( !this.data.respuestas || clearData ) {
			const data = await API.getRespuestas();
			this.data.respuestas = this.#cleanStrapiData( data );
		}

		return this.data.respuestas;
	}
	//download all respuestas
	async #getProhibicionesInt( clearData = true ) {
		
		if( !this.data.respuestas || clearData ) {
			const data = await API.getProhibicionesInt();
			this.data.prohibicionesInt = this.#cleanStrapiData( data );
		}

		return this.data.respuestas;
	}
	//download all respuestas
	async #getProhibicionesAm( clearData = true ) {
		
		if( !this.data.respuestas || clearData ) {
			const data = await API.getProhibicionesAm();
			this.data.prohibicionesAm = this.#cleanStrapiData( data );
		}

		return this.data.respuestas;
	}
	//download all respuestas
	async #getObjetos( clearData = true ) {
		
		if( !this.data.objetos || clearData ) {
			const data = await API.getObjetos();
			this.data.objetos = this.#cleanStrapiData( data );
		}

		return this.data.objetos;
	}
}